import {useLocation} from 'react-router-dom';

export default function useIsPathname(pathname?: string) {
	const location = useLocation();

	return location.pathname === pathname;
}
